import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "infocircle",
  "use": "infocircle-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\" id=\"infocircle\"><title>infocirlce</title><path d=\"M8 0Q5.828 0 3.984 1.07T1.07 3.984 0 8t1.07 4.016 2.914 2.914T8 16t4.016-1.07 2.914-2.914T16 8t-1.07-4.016-2.914-2.914T8 0zm-.047 2.875q.234 0 .398.172t.164.398-.164.391T7.953 4t-.398-.164-.164-.391.164-.398.398-.172zm2.453 8.719q0 .234-.164.398t-.398.164H6.063q-.234 0-.398-.164t-.164-.398q0-.234.164-.398t.398-.164h1.328V6.126h-.938q-.234 0-.398-.172t-.164-.391q0-.234.164-.398t.398-.164h1.5q.234 0 .398.164t.164.398v5.469h1.328q.234 0 .398.164t.164.398z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./~/wc-lib/icons/infocircle.svg
// module id = 27
// module chunks = 0